import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { Pendencia, TipoPendencia, VincularSaldosResult } from '../../interfaces/pendencia';

@Injectable({
  providedIn: 'root',
})
export class PendenciasService {
  private apiURL = environment.apiUrl + '/v' + environment.apiVersion;

  constructor(private httpClient: HttpClient) {}

  public async getPendencias(
    tipo: TipoPendencia,
    cdEstab: number,
    dtInicial: string,
    dtFinal: string,
    username: string,
  ): Promise<Pendencia[]> {
    try {
      const url =
        `${this.apiURL}/Pendencias` +
        `?tipo=${tipo}` +
        `&cdEstab=${cdEstab}` +
        `&dtInicial=${dtInicial}` +
        `&dtFinal=${dtFinal}` +
        `&username=${encodeURIComponent(username)}`;
      const response = await firstValueFrom(
        this.httpClient.get<any>(url).pipe(catchError(this.handleError)),
      );
      if (!response?.data?.length) return [];
      return response.data[0] as Pendencia[];
    } catch {
      return [];
    }
  }

  public async vincularSaldos(username: string, nrInternoConta?: number): Promise<VincularSaldosResult> {
    const body: any = { username };
    if (nrInternoConta) body.nrInternoConta = nrInternoConta;
    const response = await firstValueFrom(
      this.httpClient
        .post<any>(`${this.apiURL}/Pendencias/vincular-saldos`, body)
        .pipe(catchError(this.handleError)),
    );
    if (!response?.data?.length) throw new Error('Resposta vazia da API.');
    return response.data[0] as VincularSaldosResult;
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
